module.exports = __webpack_public_path__ + "media/images/guide-756c88b3.svg";